import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300/60 cursor-pointer"
    >
      <div className="aspect-[16/10] overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
            {article.category === 'wanfa-guize' ? '玩法规则' :
             article.category === 'kaijiang-jieguo' ? '开奖结果' :
             article.category === 'goumai-jiqiao' ? '购买技巧' :
             article.category === 'zhongjiang-gonglve' ? '中奖攻略' :
             article.category === 'kaijiang-shijian' ? '开奖时间' : '号码分析'}
          </span>
          <span className="text-xs text-foreground-500">{article.readTime}</span>
          {article.isHot && (
            <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
              热门
            </span>
          )}
        </div>
        <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors duration-200 font-heading">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="mt-3 flex items-center justify-between">
          <span className="text-xs text-foreground-500">{article.publishDate}</span>
          <span className="text-xs text-accent-600 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
            阅读全文 <i className="ri-arrow-right-line ml-0.5"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}